module.exports = __webpack_public_path__ + "img/medal01.70ba4309.svg";